import { HollowedButton, NormalButton } from '@shared/designSystem/Button';
import { HorizontalContainer, VerticalContainer } from '@shared/designSystem/Containers';
import { Modal } from '@shared/designSystem/messages/Modal';
import { BoldText, SmallText, Text } from '@shared/designSystem/Texts';
import designSystemStyles from '@shared/styles/designSystemStyles';
import { PilotCatalogTableRow } from './PilotOnboardingTableViewModel';

interface PilotOnboardingCloseModalScreenProps {
    isOpen: boolean;
    pilot: PilotCatalogTableRow | null;
    isClosing: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const PilotOnboardingCloseModalScreen: React.FC<PilotOnboardingCloseModalScreenProps> = ({
    isOpen,
    pilot,
    isClosing,
    onClose,
    onConfirm,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Cerrar piloto".localized()}
            width="620px"
            maxWidth="90vw"
        >
            <VerticalContainer gap={designSystemStyles.gapLg}>
                <VerticalContainer gap={designSystemStyles.gapSm}>
                    <BoldText text={"¿Seguro que quieres cerrar este piloto?".localized()} />
                    <Text text={"Esta accion enviara la desactivacion de la organizacion piloto a la cola de workers.".localized()} />
                </VerticalContainer>

                {pilot && (
                    <VerticalContainer
                        padding={designSystemStyles.paddingMd}
                        backgroundColor={designSystemStyles.colorBackgroundGray3}
                        borderRadius={designSystemStyles.cornerRadiusComponent}
                        gap={designSystemStyles.gapSm}
                    >
                        <SmallText text={"ID".localized()} />
                        <BoldText text={pilot.id} />
                        <SmallText text={"Nombre".localized()} />
                        <Text text={pilot.name} />
                    </VerticalContainer>
                )}

                <HorizontalContainer justifyContent="flex-end" gap={designSystemStyles.gapMd}>
                    <HollowedButton
                        text={"Cancelar".localized()}
                        onClick={onClose}
                        disabled={isClosing}
                        width="180px"
                    />
                    <NormalButton
                        text={"Cerrar piloto".localized()}
                        onClick={onConfirm}
                        loading={isClosing}
                        disabled={!pilot}
                        width="180px"
                    />
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};

export default PilotOnboardingCloseModalScreen;
